<template lang="pug">
  .eui-mapColourLegend(v-if="!currentElection.isReferendum")
    .eui-mapColourLegend_item(v-for="item in items", :class="`eui-mapColourLegend_item_${item}`")
      span.eui-mapColourLegend_item_circle
      span.eui-mapColourLegend_item_text {{ item }}

</template>

<script>

export default {
  name: 'mapColourLegend',
  props: {
  },
  data() {
    return {
      items: [ 'Lead', 'Win', 'Flip' ]
    };
  },
  computed: {
    currentElection() { return this.$store.getters.currentElection(this.currentYear); },
  }
};

</script>

<style lang="scss">
  @import "src/core/scss/global-sass";

  .eui-mapColourLegend {
    display: inline-flex;
    line-height: 1;
    // margin-top: calc(var(--spacing-unit-x2) * -1);
    margin-bottom: var(--spacing-unit);

    &_item {
      display: flex;
      align-items: center;
      margin-right: var(--spacing-unit-x2);

      &_circle {
        display: block;
        width: 14px;
        height: 14px;
        border-radius: 100%;
        margin-right: var(--spacing-unit-x0_5);
      }

      &_Lead &_circle {
        border: 1px solid var(--color-body);
      }

      &_Win &_circle {
        background-color: var(--color-body);
      }

      &_Flip &_circle {
        background: var(--color-body) repeating-linear-gradient(-45deg, rgba(255,255,255,0.4), rgba(255,255,255,0.4) 3px,  rgba(255,255,255,0) 3px, rgba(255,255,255,0) 6px)
      }

      &_text {

      }
    }

  }
</style>
